module.exports = __webpack_public_path__ + "img/11_56.54b75726.png";